import React from 'react';

import { WidgetProps } from 'components/Visualization/CDashboard/types';
import { BlueprintGeneralDetails } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/BlueprintGeneralDetails';
import { Accounts } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/Accounts';
import { BlueprintClouds } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintClouds';
import { Environments } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/Environments';
import { Exceptions } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/Exceptions';
import { Policies } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/Policies';
import { Workflows } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/Workflows';
import { PassPercentageByEnvironments } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Charts/PassPercentageByEnvironments';
import { ViolationsByAccounts } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Charts/ViolationsByAccounts';
import { ViolationsByEnvironments } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Charts/ViolationsByEnvironments';

export const blueprintDashboardWidgets: Record<string, WidgetProps> = {
  generalDetails: {
    flex: true,
    components: {
      content: <BlueprintGeneralDetails />,
    },
    styles: { root: { px: 0 } },
  },
  clouds: {
    flex: true,
    components: {
      content: <BlueprintClouds />,
    },
  },
  environments: {
    flex: true,
    components: {
      content: <Environments />,
    },
  },
  accounts: {
    flex: true,
    components: {
      content: <Accounts />,
    },
  },
  policies: {
    flex: true,
    components: {
      content: <Policies />,
    },
  },
  exceptions: {
    flex: true,
    components: {
      content: <Exceptions />,
    },
  },
  workflows: {
    flex: true,
    components: {
      content: <Workflows />,
    },
  },
};

export const blueprintDashboardSummaryWidgets: Record<string, WidgetProps> = {
  violationsByEnvironments: {
    flex: true,
    components: {
      content: <ViolationsByEnvironments />,
    },
  },
  violationsByAccounts: {
    flex: true,
    components: {
      content: <ViolationsByAccounts />,
    },
  },
  passPercentageByEnvironments: {
    flex: true,
    components: {
      content: <PassPercentageByEnvironments />,
    },
  },
};
